<template>
    <div>
        <div id="ndi-qr"></div>
        <el-row :gutter="12" v-if="loggedInUsers.length" :style="{marginBottom: '10px'}">
            <el-col :span="24">
                <transition-group tag="div">
                    <el-card
                        v-for="(user) in loggedInUsers"
                        :class="{loggedOutUserList: (user.pivot.active !== 'Yes') }"
                        :key="`${user.id}_logged_in_user`"
                        :style="{marginBottom: '5px'}"
                    >
                        <el-row>
                            <el-col :span="12" align="left">
                                <a @click="goLandingPage(user)">{{user.name}}</a>
                            </el-col>
                            <el-col :span="12" align="right">
                                <a v-if="user.pivot.active !== 'Yes'">Logged Out |</a>
                                <a @click="userRevoked(user)">Remove</a>
                            </el-col>
                        </el-row>
                    </el-card>
                </transition-group>
            </el-col>
            <el-col v-if="!showLogin" :span="24" align="right" :style="{marginTop: '10px'}">
                <a
                    v-if="loggedInUsers.length <= 3"
                    @click="displayLoginForm"
                >Login with Different Account</a>
                <p
                    v-else
                >Max 3 users can login on a browser at a time. You can remove a user to login with new one.</p>
            </el-col>
        </el-row>
        <login-form v-if="showLogin && loggedInUsers.length <= 3" />
    </div>
</template>

<script>
import LoginForm from './form/LoginForm';

export default {
    name: 'Login',
    components: {
        LoginForm
    },
    data: function() {
        return {
            loggedInUsers: [],
            showLogin: true
        };
    },
    created: function() {
        const loading = this.$loading({ lock: true });
        this.axios('device/user')
            .then(response => {
                loading.close();
                this.loggedInUsers = response.data.device_users;

                if (this.loggedInUsers.length) {
                    this.showLogin = false;
                }
            })
            .catch(() => {
                loading.close();
            });
        setTimeout(() => {
        //    alert('call');
           // this.initQR()
        }, 3000);
        
        
        if( this.$route.query.code && this.$route.query.state  )
        {
            this.axios.post('singpass-auth-code', { code: this.$route.query.code, state: this.$route.query.state, nonce:"412557b5-c6e8-43b5-ad8c" })
            .then(response => {
                
                
            //     this.axios.post('https://stg-id.singpass.gov.sg/token', { code: this.$route.query.code, scope: this.$route.query.state })
            //                 .then(response => {
                                
            //                       alert('api call')
            //                 })
            //                 .catch(() => {
            //                     alert('went wrong')
            //                 });
            
            
                 
                alert('api call')
            })
            .catch(() => {
                
                // const headers = {
                //       //'Content-Type': 'application/x-www-form-urlencoded; charset=ISO-8859-1',
                //       'content-type': 'application/json'
                //     }





                    
                
                
                
//                 this.axios.post('https://stg-id.singpass.gov.sg/token', { code: this.$route.query.code, scope: this.$route.query.state, client_assertion_type: 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
// client_assertion:'eyJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJzdWIiOiJ5S2lnVkppTkhHYmUyVFZEdnVhM1FXQzBGbEhiQ0Z6WCIsImF1ZCI6Imh0dHBzOlwvXC9zdGFnaW5nLnJhZG1hZ2l4LmNvbVwvIiwiaXNzIjoieUtpZ1ZKaU5IR2JlMlRWRHZ1YTNRV0MwRmxIYkNGelgiLCJpYXQiOjE2MTc3NjgzNzMuOTI0OTc3LCJleHAiOjE4NzM3NjgzNzMuOTI0OTc3fQ.5Ydu7eeDcmoZhWnJTEXxKgsiWZ3TJeLtHhzpttNduIT724EQbimtXFIPUFU7Iv51cf5umZmEfKGuiViy2RzYuw',
// client_id:'yKigVJiNHGbe2TVDvua3QWC0FlHbCFzX',
// grant_type:'authorization_code',
// redirect_uri:'https://staging.radmagix.com/' }, {
//     headers: headers
//   })
//                             .then(response => {
                                
//                                   alert('ok')
                                  
//                             })
//                             .catch(() => {
//                                 alert('failed')
//                             });
                alert('went wrong')
            });
        }
        
        
    },
    methods: {
        /**
         * To Remove the user for this device.
         */
        userRevoked: function(user) {
            const loading = this.$loading({ lock: true });
            this.axios
                .put(`device/user/${user.id}/revoke`)
                .then(response => {
                    loading.close();
                    //this.$message.success(response.message);

                    this.loggedInUsers.map((u, index) => {
                        if (u.id === user.id) {
                            this.$helper.deleteProp(
                                this.loggedInUsers,
                                index.toString()
                            );

                            this.$nextTick(function() {
                                if (this.loggedInUsers.length === 0) {
                                    this.showLogin = true;
                                }
                            });
                        }
                    });
                })
                .catch(() => {
                    loading.close();
                });
        },
        goLandingPage: function(user) {
            if (user.pivot.active === 'Yes') {
                let url = [
                    user.role.landing_page.replaceAll(/^\/|\/$/g, ''),
                    'u',
                    user.pivot.login_index
                ]
                    .join('/')
                    .replaceAll(/^\/|\/$/g, '');

                const landing_uri = this.$helper.getProp(
                    user,
                    'role.settings.landing_uri'
                );
                if (landing_uri) {
                    url = url + '/' + landing_uri.replaceAll(/^\/|\/$/g, '');
                }
                window.location.href = url;
            } else {
                this.showLogin = true;
                this.$nextTick(() => {
                    this.$lqForm.setElementVal(
                        this.formName,
                        'email',
                        user.email
                    );
                });
            }
        },

        logout: function(user) {
            const url = [
                user.role.landing_page.replaceAll(/^\/|\/$/g, ''),
                'u',
                user.pivot.login_index
            ]
                .join('/')
                .replaceAll(/^\/|\/$/g, '');
            window.location.href = url + '/logout';
        },
        displayLoginForm: function() {
            this.showLogin = true;
        },
        initQR: function() {
            alert('init')
            var headers = new Headers();
            
            const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');


            const authParamsSupplier = async () => {
               //  return { state: "dummySessionState", nonce: "dummySessionNonce" };
              //   return   { state: "f67bbc97-6804-4c77-b1ea-4b20a678d545", nonce: "412557b5-c6e8-43b5-ad8c-c467a6b4a51f" };
              // Replace the below with an `await`ed call to initiate an auth session on your backend
              // which will generate state+nonce values, e.g
              return  await { state: "f67bbc97-6804-4c77-b1ea-"+ genRanHex(12), nonce: "412557b5-c6e8-43b5-ad8c"};
            };
        
            console.log(authParamsSupplier)
            console.log(authParamsSupplier())
            const onError = (errorId, message) => {
              console.log(`onError. errorId:${errorId} message:${message}`);
            };
        
            const initAuthSessionResponse = window.NDI.initAuthSession(
              'ndi-qr',
              {
                clientId: 'yKigVJiNHGbe2TVDvua3QWC0FlHbCFzX', // Replace with your client ID
                redirectUri: 'https://staging.radmagix.com/',        // Replace with a registered redirect URI
                scope: 'openid',
                responseType: 'code',
                mode: 'cors',
                credentials: 'include'
              },
              authParamsSupplier,
              onError
            );
        
            console.log('initAuthSession: ', initAuthSessionResponse);
        },
        /**
         * When Form is not validated/
         */
        haveError: function() {}
    },
    mounted() {
        const plugin = document.createElement("script");
        plugin.setAttribute(
          "src",
          "https://stg-id.singpass.gov.sg/static/ndi_embedded_auth.js"
        );
        plugin.async = true;
        document.head.appendChild(plugin);
    }
};
</script>

<style>
.loggedOutUserList {
    border: 0px;
}

.loggedOutUserList .el-card__body {
    background: #289b9c;
    color: #28bec0;
}
</style>

